import { isItemIndexed } from '~~/shared/items/itemPending'

/**
 * The five states in which a document has something to say other than its date.
 *
 * One definition, because there were nearly three. `DocumentStatusChip` enumerates these states to
 * decide what to render; its callers need the same answer to decide whether to render the chip *or*
 * the timeAgo. Deriving it independently as "any status that is not `ready`" looks equivalent and is
 * not: `items.status` also carries `draft`, `uploaded` and `null`, which are perfectly settled. That
 * version rendered a chip that drew nothing and swallowed the date with it, leaving a blank trailing
 * column on every document that had not been through indexing.
 */
export function isUnsettled(item: { status?: string | null; pending_read?: boolean | null }): boolean {
  return !isItemIndexed(item.status) || !!item.pending_read
}
